<template>
  <div class="body">
    <el-card class="box_card">
      <div class="header">
        <div class="header_title bold">订单/报告查询</div>
        <div class="header_right">
          <div class="header_item">
            <span class="item_title"> 时间选择：</span>
            <el-date-picker v-model="dateValue" type="daterange" :picker-options="pickerOptions"
              value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"
              :editable="false" :clearable="false" @change="chooseDate">
            </el-date-picker>
          </div>
          <div class="header_item">
            <span class="item_title">报告状态：</span>
            <el-select v-model="typeValue" placeholder="请选择" @change="chooseType">
              <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="header_item">
            <!-- <span class="item_title">打印状态：</span> -->
            <el-select v-model="printValue" placeholder="请选择" @change="chooseType">
              <el-option v-for="item in printOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </div>
          <div class="header_item">
            <el-input v-model="searchName" placeholder="输入患者姓名查询" clearable prefix-icon="el-icon-search"
              @clear="clearSearchName" @keyup.enter.native="goSearch"></el-input>
          </div>
          <div class="header_item" style="margin-right: 50px;">
            <el-button type="primary" plain icon="el-icon-search" size="small" @click="goSearch"
              style="width: 100px;">搜索</el-button>
            <el-button v-if="showBtn" type="warning" plain icon="el-icon-printer" :loading="isPrintShow"
              style="margin-left: 10px" @click="batchPrint">
              {{ isPrintShow ? '正在启动打印,请稍后...' : '批量打印' }}
            </el-button>
          </div>
        </div>
      </div>
      <div class="middle_table">
        <el-table ref="multipleTable" :data="tableData" stripe v-loading="laodTable" element-loading-text="数据加载中"
          element-loading-spinner="el-icon-loading" border style="width: 100%" height="100%"
          @select-all="handleSelectionChange($event)" @select="selectCheck">
          <el-table-column type="selection" width="55" align="center"></el-table-column>
          <el-table-column type="index" label="序号" width="50" align="center"> </el-table-column>
          <el-table-column prop="documentNo" label="订单编号" width="160" align="center"> </el-table-column>
          <el-table-column prop="" label="报告状态" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag type="success" v-if="typeValue === '报告已出'">报告已出 </el-tag>
              <el-tag type="warning" v-if="typeValue === '报告未出'">报告未出</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="orderStaus" label="结算状态" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag type="success" v-if="row.orsl_Payment_status === '已结算'">{{ row.orsl_Payment_status }}</el-tag>
              <el-tag type="info" v-if="row.orsl_Payment_status === ''">未结算</el-tag>
              <el-tag type="warning" v-if="row.orsl_Payment_status === '准备支付' || row.orsl_Payment_status === '待支付'">{{
                row.orsl_Payment_status
              }}</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="patientName" label="姓名" width="100" align="center"> </el-table-column>
          <el-table-column prop="patientSex" label="性别" width="100" align="center"> </el-table-column>
          <el-table-column prop="patientAge" label="年龄" width="100" align="center"> </el-table-column>
          <!-- <el-table-column prop="cml_Customer_ID" label="患者ID" width="180" align="center"> </el-table-column> -->
          <el-table-column prop="patientMobile" label="手机号" width="140" align="center"> </el-table-column>
          <el-table-column prop="barcode" label="条码" width="180" align="center">
            <template slot-scope="scope">
             <div v-for="(item, index) in scope.row.barcode.split(',')" :key="index">
              {{ item }}
             </div>
            </template>
          </el-table-column>
          <el-table-column prop="pslName" label="检验项目" align="center"  width="360">
            <template slot-scope="scope"> 
             <div style="display: flex;justify-content: center;">
              <div style="width: fit-content;min-width: 300px;text-align: left;"  >                             
                <div v-for="(item, index) in scope.row.pslName.split(',')" :key="index">
                   {{ item }} 
                </div>
               </div>     
              </div>                     
            </template>
          </el-table-column>
          <!-- <el-table-column prop="orderStaus" label="是否总检" width="120" align="center">
            <template slot-scope="{ row }">
              <el-tag type="success"
                v-if="row.orsl_Whether_to_interpret == '是' && row.orsl_Interpretation_state == '已总检'">已总检</el-tag>
              <el-tag type="warning"
                v-if="row.orsl_Whether_to_interpret == '是' && !row.orsl_Interpretation_state">未总检</el-tag>
            </template>
          </el-table-column> -->
          <el-table-column prop="createTime" label="创建时间" align="center"> </el-table-column>
          <!-- <el-table-column prop="orsl_Settlement_time" label="结算时间" width="160" align="center"> </el-table-column> -->
          <el-table-column prop="" label="操作" align="center" fixed="right" width="100">
            <template slot-scope="{ row }">
              <span v-if="typeValue === '报告已出'" style="font-size: 13px; color: #36b6ff; cursor: pointer"
                @click.stop="clickRow(row)" class="view_report">
                查看报告
              </span>
              <span v-if="typeValue === '报告未出'" style="font-size: 13px; color: #36b6ff; cursor: pointer"
                class="view_report">
                暂无操作
              </span>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div class="bottom_pagination">
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="pageNumber" :page-sizes="[20, 30, 50, 100]" :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="totalNum">
        </el-pagination>
      </div>
    </el-card>
    <div class="batch-print" ref="printAll" style="box-sizing: border-box;">
      <div class="image-container" style="page-break-after:always;box-sizing: border-box;"
        v-for="(item, index) of printImageUrls" :key="index">
        <img :src="item" style="width: 100%;" />
      </div>
    </div>
  </div>
</template>

<script>
import bus from '../../common/bus.js';
import printJs from '@/utils/print2.js';
import request from '@/utils/request';
import moment from 'moment';
export default {
  name: 'QueryIndex',
  data() {
    return {
      showBtn: true,
      isPrintShow: false,
      clinicInfo: {},
      laodTable: false,
      pageNumber: 1,
      pageSize: 20,
      tableData: [],
      totalNum: 0,
      searchName: '', //搜索名称
      dateValue: [], //搜索时间数组
      startTime: '', //左侧时间
      endTime: '', //右侧时间
      pickDate: '',// 存放getPickDate获取的数据
      pickerOptions: {
        onPick: this.getPickDate,
        disabledDate: this.disabledDate
      },
      typeOptions: [
        {
          value: '报告已出',
          label: '报告已出'
        },
        {
          value: '报告未出',
          label: '报告未出'
        }
      ],
      typeValue: '报告已出',
      printOptions: [
        {
          value: '全部',
          label: '全部'
        },
        {
          value: '未打印',
          label: '未打印'
        },
        {
          value: '已打印',
          label: '已打印'
        },
      ],
      printValue: "全部",
      isBatchPrint: false,
      printArr: [], //批量打印数组
      printImageUrls: []
    };
  },
  created() {
    this.clinicInfo = JSON.parse(sessionStorage.user);
    this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
    this.startTime = moment(new Date().getTime() - 7000 * 60 * 60 * 24).format('YYYY-MM-DD');
    this.dateValue = [this.startTime, this.endTime]; //回显
    // this.getAllOverReportList(); //报告未出
    this.getReportListYj();
  },
  mounted() { },
  methods: {
    // 禁用三个月内
    getPickDate(pick) {
      this.pickDate = pick;
    },
    disabledDate(date) {
      const { minDate, maxDate } = this.pickDate;
      if (minDate && !maxDate) {
        const diff = Math.abs(minDate.valueOf() - date.valueOf());
        if (diff > 1000 * 3600 * 24 * 360) {
          return true;
        }
      }
    },
    //批量打印点击事件
    batchPrint() {
      const that = this;
      if (that.printArr.length === 0) {
        that.$message.warning('抱歉，请选择需要批量打印的订单报告!');
        return false;
      }
      // this.isPrintShow = true;
      const loading = this.$loading({
        lock: true,
        text: '打印机正在启动中，请耐心等候...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      // 请求数据
      let params = {
        documentNos: that.printArr.map(el => el.documentNo)
      };
      request
        .post('/queryReportPaths2', params, { category: 'WuFan' })
        .then((res) => {
          if (res.success) {
            // console.log("xx:", res)1
            that.printImageUrls = []
            let paramsIDs = []
            res.data.forEach(item => {
              that.printImageUrls.push(item.reportUrl)
              paramsIDs.push(item.reportId)
            });
            setTimeout(() => {
              loading.close();
              printJs(that.$refs.printAll, {
                noPrint: '.noPrint',
                onStart: () => {
                  console.log('打印开始1');
                },
                onEnd: () => {
                  let params2 = {
                    reportIds: paramsIDs
                  };
                  request.post('/updatePrintStatus', params2, { category: 'WuFan' }).then((resp) => {
                    if (resp.success) {
                      // console.log("xxxx")
                      that.printArr = [];
                      that.getReportListYj()
                    }
                  })
                }
              });
              // that.tableData.forEach((item, index) => {
              //   that.printArr.forEach((item2) => {
              //     if (item.documentNo === item2.documentNo) {
              //       that.$refs.multipleTable.toggleRowSelection(item, false);
              //     }
              //   });
              // });
              // that.printArr = [];
            }, that.printArr.length * 200);

          } else {
            that.$message.error('抱歉，查询报告路劲列表出错');
          }
        }).catch(() => {
          loading.close();
          that.$message.error('抱歉，查询报告路劲列表出错2');

        })
    },
    // 单行选中或非选中取消 方法
    selectCheck(selection, row) {
      const vm = this;
      const isHaveItem = vm.printArr.find((item) => item.documentNo === row.documentNo);
      if (isHaveItem) {
        vm.printArr = vm.printArr.filter((item) => item.documentNo !== isHaveItem.documentNo);
      } else {
        vm.printArr.push(row);
      }
    },

    //全部选中或非选中取消 方法
    handleSelectionChange(val) {
      const vm = this;
      if (val.length > 0) {
        for (const key of val) {
          if (!vm.printArr.find((item) => item.documentNo === key.documentNo)) {
            vm.printArr.push(key);
          }
        }
      } else {
        if (vm.printArr.length > 0) {
          for (const row of vm.tableData) {
            vm.printArr = vm.printArr.filter((item) => item.documentNo !== row.documentNo);
          }
        }
      }
    },
    // 查看报告
    clickRow(row) {
      bus.$emit('aliveTags', ['QueryIndex']); //缓存页面
      this.$router.push({ path: '/reportDetail', query: { documentNo: row.documentNo, sorucePath: 'queryIndex' } });
      // if (row.orderStaus === 4) {
      //   //退单 改项
      //   this.$router.push({ path: '/chargeBack', query: { id: '10122' } });
      // } else {
      //   // 报告已出 部分未出
      //   localStorage.setItem('reportDetail', JSON.stringify(row)); //保存数据
      //   this.$router.push({ path: '/queryInfo', query: { customerId: row.customerId, sorucePath: 'queryIndex' } });
      // }
    },
    //选择报告类型--改版
    chooseType(event) {
      this.pageNumber = 1;
      this.pageSize = 20;
      this.totalNum = 0;
      if (event === '报告未出') {
        this.isPrintShow = false;
        this.showBtn = false;
        this.printArr = [];
        this.getReportListYj();
      } else {
        this.showBtn = true;
        this.printArr = [];
        this.getReportListYj();
      }
    },
    // 条目数
    handleSizeChange(val) {
      this.pageNumber = 1;
      this.pageSize = val;
      this.getReportListYj();
    },
    // 页码数
    handleCurrentChange(val) {
      this.pageNumber = val;
      this.getReportListYj();
    }, 
    // 点击搜索--改版
    goSearch() {
      this.pageNumber = 1;
      this.getReportListYj()
    },
    //清除按钮--改版
    clearSearchName() {
      this.searchName = '';
      this.pageNumber = 1;
      // this.pageSize = 20;
      this.getReportListYj()
    },
    // 选择时间
    chooseDate(event) {
      if (event) {
        this.startTime = event[0];
        this.endTime = event[1];
        this.pageNumber = 1;
        this.pageSize = 20;
      } else {
        this.endTime = moment(new Date().getTime()).format('YYYY-MM-DD');
        this.startTime = moment(new Date().getTime() - 1000 * 60 * 60 * 24).format('YYYY-MM-DD');
        this.pageNumber = 1;
        this.pageSize = 20;
      }
      this.getReportListYj()
    },
    // 获取列表--改版
    getReportListYj() {
      const that = this;
      that.laodTable = true;
      let params = {
        calCode: that.clinicInfo.cal_code,
        keyword: that.searchName,
        reportStatus: that.typeValue == '报告已出' ? 1 : 0,
        printStatus: that.printValue ? that.printValue : "",//打印状态
        startTime: that.startTime + " 00:00:00",
        endTime: that.endTime + " 23:59:59",
        current: that.pageNumber,
        size: that.pageSize
      };
      let personType = {
        category: 'WuFan'
      };
      request
        .post('/getReportList', params, personType)
        .then((res) => {
          that.laodTable = false;
          if (res.success) {
            that.tableData = res.data.records;
            that.totalNum = Number(res.data.total);
          } else {
            that.$message.error('抱歉，查询数据列表出错');
          }
        })
        .then((res) => {
          if (that.printArr.length > 0) {
            that.tableData.map((item, index) => {
              that.printArr.map((item2, index2) => {
                if (item.documentNo === item2.documentNo) {
                  that.$refs.multipleTable.toggleRowSelection(item, true);
                }
              });
            });
          }
        })
        .catch((err) => {
          // that.laodTable = false;
          // that.$message.error('抱歉，查询数据列表出错');
        });
    },
  }
};
</script>
<style media="print">
@page {
  size: auto;
  margin: 3nm;
}

html {
  background-color: #ffffff;
  height: auto !important;
  margin: 0px;
  overflow: auto !important;

}

.image-container {
  width: 100%;
  /* 容器宽度占满纸张宽度 */
  page-break-after: always;
  /* 每个图片容器后都强制分页 */
}

/* 调整图片大小以适应纸张并保持比例 */
.image-container img {
  max-width: 100%;
  max-height: 98vh;
  /* 图片最大高度略小于视口高度 */
  object-fit: contain;
  /* 保持图片比例并包含在容器内 */
}
</style>

<style lang="scss" scoped>
.view_report:hover {
  color: #36b6ff !important;
  font-weight: bold;
}

.body {
  width: 100%;
  height: calc(100vh - 90px);
  box-sizing: border-box;
  position: relative;

  .batch-print {
    position: absolute;
    top: 0;
    left: 20000px;
    z-index: 10000;
  }

  ::v-deep .el-card__body {
    height: 100% !important;
    width: 100% !important;
    padding: 0px !important;
    border-radius: 30px 30px 0px 0px !important;
  }

  ::v-deep .el-card {
    border-radius: 30px 30px 0px 0px !important;
  }

  .box_card {
    height: calc(100vh - 90px);
    box-sizing: border-box;

    .header {
      box-sizing: border-box;
      padding: 10px 30px;
      background-color: #f0feff;
      border-radius: 30px 30px 0px 0px;
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;

      @media screen and (max-width: 1024px) {
        padding: 10px 12px;
      }

      .header_title {
        font-size: 20px;
        color: #2d99d7;
      }

      .header_right {
        display: flex;

        .header_item {
          display: flex;
          align-items: center;
          align-content: center;
          margin: 0 5px;

          .item_title {
            color: #333;
            font-size: 16px;
            font-weight: 400;
            margin-right: 20px;
            margin-left: 20px;
            flex-shrink: 0;
          }

          &:first-child>.item_title {
            margin-left: 0;
          }

          @media screen and (max-width: 1024px) {
            .item_title {
              letter-spacing: 13px;
            }
          }

          ::v-deep .el-date-editor {
            width: 240px;
          }
        }
      }
    }

    .middle_table {
      height: calc(100% - 120px);
      width: 100%;
      box-sizing: border-box;
      padding: 0 10px;
    }

    .bottom_pagination {
      width: 100%;
      margin-top: 10px;
      height: 40px;
      display: flex;
      justify-content: center;
      justify-items: center;
      align-items: center;
    }
  }
}
</style>
